import React, { useEffect, useRef } from "react";

const BankingSolutions = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .solutions-container {
        width: 100%;
        padding: 40px 20px;
        background-color: white;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .solutions-header {
        text-align: center;
        max-width: 900px;
        margin-bottom: 40px;
        
      }

      .solutions-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 10px;
        letter-spacing:0px;
        
      }

      .solutions-subtitle {
        color:black;
        font-size: 18px;
        //  text-align:justify;
         font-weight:bold;
      }

      .solutions-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 25px;
        max-width: 1200px;
        width: 100%;
      }

      .solution-card {
        background: #fff;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        opacity: 0; /* hidden initially */
        transform: translateY(50px);
        transition: opacity 0.6s ease, transform 0.6s ease;
      }

      .solution-card.visible {
        opacity: 1;
        transform: translateY(0);
      }

      /* Random animations */
      .from-left { transform: translateX(-100px); }
      .from-right { transform: translateX(100px); }
      .from-bottom { transform: translateY(100px); }
      .from-top { transform: translateY(-100px); }

      .solution-card.visible.from-left,
      .solution-card.visible.from-right,
      .solution-card.visible.from-bottom,
      .solution-card.visible.from-top {
        transform: translateX(0) translateY(0);
        opacity: 1;
      }

      .solution-image {
        width: 100%;
        height: 200px;
        object-fit: cover;
        transition: transform 0.4s ease;
      }

      .solution-card:hover .solution-image {
        transform: scale(1.1);
      }

      .solution-content {
        padding: 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .solution-title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
        color:black;
      }

      .solution-desc {
        font-size: 16px;
        color: #444;
       
      }

      /* Responsiveness */
      @media (max-width: 1024px) {
        .solutions-grid {
          grid-template-columns: repeat(2, 1fr);
        }
      }

      @media (max-width: 600px) {
        .solutions-grid {
          grid-template-columns: 1fr;
        }
      }
    `;
    document.head.appendChild(style);

    const cards = containerRef.current.querySelectorAll(".solution-card");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.2 }
    );

    // Assign random entry animation (left, right, top, bottom)
    const directions = ["from-left", "from-right", "from-top", "from-bottom"];
    cards.forEach((card) => {
      const randomClass = directions[Math.floor(Math.random() * directions.length)];
      card.classList.add(randomClass);
      observer.observe(card);
    });

    return () => {
      document.head.removeChild(style);
      observer.disconnect();
    };
  }, []);

  const solutions = [
    {
      img: "/image/Equity-Capital-Markets.jpg",
      title: "Capital markets",
      desc: "In the capital markets landscape, navigating multiple strategic objectives demands advanced solutions that keep pace with business and technological shifts."
    },
    {
      img: "/image/upi-credit-cards.png",
      title: "Cards and payments",
      desc: "Now is the time to consolidate your competitive position using digital solutions, while maximizing your return on investment."
    },
    {
      img: "/image/financial-crime-banner-image.webp",
      title: "Financial crime and compliance",
      desc: "Regulatory compliance in finance and risk management remains a critical requirement for banks. Our approach helps streamline anti-financial crime programs."
    },
    {
      img: "/image/lending-in-banking.jpg",
      title: "Lending",
      desc: "Lending models need to be simpler, faster, and personalized for customers. We help lenders create seamless digital lending experiences."
    },
    {
      img: "/image/retailbank.jpg",
      title: "Retail and commercial banking",
      desc: "To create long-term value, banks must meet changing customer expectations. We help deliver personalized digital experiences."
    },
    {
      img: "/image/wealthmngnt.webp",
      title: "Wealth management and retirement",
      desc: "Customer and industry dynamics for wealth management firms are transforming rapidly. We empower advisors with data-driven insights."
    }
  ];

  return (
    <div className="solutions-container" ref={containerRef}>
      <div className="solutions-header">
        <h2 className="solutions-title">Digital banking solutions</h2>
        <p className="solutions-subtitle">
          Leverage our expert banking consulting solutions to optimize operations,
          mitigate risk, and accelerate digital transformation.
        </p>
      </div>

      <div className="solutions-grid">
        {solutions.map((item, index) => (
          <div className="solution-card" key={index}>
            <img src={item.img} alt={item.title} className="solution-image" />
            <div className="solution-content">
              <h3 className="solution-title">{item.title}</h3>
              <p className="solution-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BankingSolutions;
